<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>查询工单</el-breadcrumb-item>
        </el-breadcrumb>
        <el-input placeholder="输入 工单主题 或 工单号" v-model="inputVal" clearable @clear="getList" @keyup.enter.native="getList(inputVal.trim())" class="search_box">
            <el-button slot="append" icon="el-icon-search" :loading="!searchFlag" @click="getList(inputVal.trim())"></el-button>
        </el-input>
            <el-table
                    :data="tableList"
                    :height="theight"
                    :row-key="getRowKey"
                    :default-sort = "{prop: 'createdAt', order: 'descending'}"
                    style="width: 100%">
                <el-table-column
                        prop="name"
                        min-width="240"
                        label="工单主题">
                    <template slot-scope="scope">
                        <el-button type="text" @click="toDetail(scope.row)">{{scope.row.name}}</el-button>
                        <!--                    <router-link :to="{path:'/home/detail',query:{id:scope.row.id,No:scope.row.caseNo,title:scope.row.name}}">{{scope.row.name}}</router-link>-->
                    </template>
                </el-table-column>
                <el-table-column
                        prop="caseNo"
                        label="工单编号">
                </el-table-column>
                <el-table-column
                        prop="caseStatus"
                        label="工单状态">
                </el-table-column>
                <el-table-column
                        prop="SVCStartTime__c"
                        label="受理时间">
                </el-table-column>
                <el-table-column
                        prop="createdAt"
                        label="创建时间">
                </el-table-column>
            </el-table>
            <el-pagination
                    style="text-align:center"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
            </el-pagination>
        <el-drawer
                :title="title"
                :visible.sync="drawer"
                size="70%"
                :with-header="true">
            <orderDetail :id="detailId" @childFn="receive" ref="detail"></orderDetail>
        </el-drawer>
    </div>
</template>

<script>
    import {getCaseList} from "../request/api";
    import orderDetail from "./orderDetail";
    export default {
        name: "historyOrder",
        components: {
            orderDetail
        },
        data(){
            return {
                theight:0,
                list:[],
                total:0,
                caseStatus:[
                    {value:1,label:'待分配'},
                    {value:2,label:'待处理'},
                    {value:3,label:'处理中'},
                    {value:4,label:'待回复'},
                    {value:5,label:'已解决'},
                    {value:6,label:'已完成'}
                ],
                pageSize:10,
                pageNum:1,
                detailId:'',
                title:'',
                drawer:false,
                inputVal:'',
                searchFlag:true,
            }
        },
        computed: {
            tableList () {
                return this.list.slice((this.pageNum-1)*this.pageSize,this.pageNum*this.pageSize)
            }
        },
        watch:{
            $route(){
                if(this.$route.params.fresh){
                    this.getList()
                }
            }
        },
        mounted(){
            this.getList()
            this.$nextTick(function(){
                this.theight=document.body.clientHeight - 220;
            })
        },
        methods:{
            getRowKey (row) {
                return row['id']+(Math.floor(Math.random()*100))
            },
            handleSizeChange(val) {
                this.pageSize=val
                this.pageNum=1
               // this.getList()
            },
            handleCurrentChange(val) {
                this.pageNum=val
               // this.getList()
            },
            getList(str){
                this.pageNum=1
                // this.list=[]
                // this.total=0
                let name=str?str.trim():''
                let id=this.$store.state.id
                let email=this.$store.state.email
                  getCaseList(id,name,email).then(res=>{
                    if(res.data.status==0){
                         this.list=res.data.data.records || []
                         this.total=res.data.data.totalSize
                         if(this.list.length){
                            this.list.forEach(item=>{
                                 if(item.createdAt){
                                        item.createdAt=this.format(Number(item.createdAt))
                                    }
                                    if(item['SVCStartTime__c']){
                                        item['SVCStartTime__c']=this.format(Number(item['SVCStartTime__c']))
                                    }
                            })
                         }
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            receive(val){
                this.title='#'+val.caseNo+' '+val.name
            },
            toDetail(row){
                this.detailId=row.id
                this.drawer=true
                this.$nextTick(function(){
                    this.$refs.detail.getDetail()
                })

               // this.receive()
            },
            isNull(name) {
                if (name == undefined || name == null) {
                    return ''
                } else {
                    return name
                }
            },
            add0(m) {
                return m < 10 ? '0' + m : m
            },
            format(timeStamp) {
                var time = new Date(timeStamp);
                var y = time.getFullYear();
                var m = time.getMonth() + 1;
                var d = time.getDate();
                var h = time.getHours();
                var mm = time.getMinutes();
                var s = time.getSeconds();
                return y + '-' + this.add0(m) + '-' + this.add0(d) + ' ' + this.add0(h) + ':' + this.add0(mm) + ':' + this.add0(s);
            },
            compare(arr,key){
                return arr.sort(function(a,b){
                    return b[key] - a[key]
                })
            }
        }
    }
</script>

<style>
    .index_content{
        display: flex;
        height:100%;
        overflow: auto;
    }
    .search_box{
        width:500px;
        position: absolute;
        top:68px;
        right:15px;
    }
    .search_box .el-input-group__append .el-button{
        margin:0;
    }
    .el-drawer__header{
        margin-bottom:10px;
        font-weight:bold;
        color:inherit;
    }
    .el-drawer__body{
        position: relative;
    }
    .el-pagination{
        margin-top:20px;
    }
    .el-drawer{
        padding-bottom:10px;
    }
</style>